// ================================
// Configuración por dominio
// ================================

const DOMAIN_CONFIG_MAP = {
  // ==============================
  // SEREC
  // ==============================
  "ecommerce.serec-ecuador.com": {
    myaccountId: 5035,
    colors: {
      primary: "#ff2400",
      secondary: "#000000",
      background: "#ffffff",
      text: "#111827",
    },
  },

  // ==============================
  // CLIENTE 2
  // ==============================
  "cliente2.com": {
    myaccountId: 8543,
    colors: {
      primary: "#12A35A",
      secondary: "#000000",
      background: "#ffffff",
      text: "#111827",
    },
  },
  "www.cliente2.com": {
    myaccountId: 8543,
    colors: {
      primary: "#12A35A",
      secondary: "#000000",
      background: "#ffffff",
      text: "#111827",
    },
  },

  // ==============================
  // CLIENTE 3
  // ==============================
  "cliente3.com": {
    myaccountId: 5036,
    colors: {
      primary: "#000000",
      secondary: "#000000",
      background: "#ffffff",
      text: "#111827",
    },
  },
  "www.cliente3.com": {
    myaccountId: 5036,
    colors: {
      primary: "#000000",
      secondary: "#000000",
      background: "#ffffff",
      text: "#111827",
    },
  },

  // ==============================
  // ULTRA (DEV / VERCEL)
  // ==============================
  "ultra-e-commerce.vercel.app": {
    myaccountId: 5035,
    colors: {
      primary: "#ff2400",
      secondary: "#000000",
      background: "#ffffff",
      text: "#111827",
    },
  },

  // ==============================
  // SERVIDOR DE PRUEBAS
  // ==============================
  "136.243.14.23": {
    myaccountId: 5035,
    colors: {
      primary: "#ff2400",
      secondary: "#000000",
      background: "#ffffff",
      text: "#111827",
    },
  },
};

// ================================
// CONFIGURACIÓN LOCAL (NO AFECTA PROD)
// ================================

// 👇 CAMBIA SOLO ESTE VALOR PARA PROBAR OTRA CUENTA EN LOCAL
const LOCAL_MYACCOUNT_ID = 5035;

const isLocalhost = () => {
  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1";
};

// ================================
// Helpers (NO rompen nada)
// ================================

export const getMyAccountId = () => {
  const host = window.location.hostname;

  // 🔥 LOCAL → depende SOLO de la cuenta
  if (isLocalhost()) {
    return LOCAL_MYACCOUNT_ID;
  }

  // 🌍 PRODUCCIÓN → depende del dominio (incluye www)
  return DOMAIN_CONFIG_MAP[host]?.myaccountId || 5035;
};

export const getBrandColors = () => {
  const host = window.location.hostname;

  // 🔥 LOCAL → colores por cuenta
  if (isLocalhost()) {
    const entry = Object.values(DOMAIN_CONFIG_MAP).find(
      (cfg) => cfg.myaccountId === LOCAL_MYACCOUNT_ID
    );
    return entry?.colors || DOMAIN_CONFIG_MAP["ecommerce.serec-ecuador.com"].colors;
  }

  // 🌍 PRODUCCIÓN → colores por dominio (incluye www)
  return (
    DOMAIN_CONFIG_MAP[host]?.colors ||
    DOMAIN_CONFIG_MAP["ecommerce.serec-ecuador.com"].colors
  );
};

export const getLogoUrl = (cedula, bustCache = false) => {
  const isLocal =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  const base = isLocal
    ? `http://localhost:8080/logos/${cedula}.jpg`
    : `https://www.ultra-erp.pro/logos/${cedula}.jpg`;

  return bustCache ? `${base}?${Date.now()}` : base;
};

export const getUserPhotoUrl = (username, bustCache = false) => {
  const isLocal =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  const base = isLocal
    ? `${window.location.protocol}//localhost:8080/images/${username}.jpg`
    : `https://www.ultra-erp.pro/images/${username}.jpg`;

  return bustCache ? `${base}?${Date.now()}` : base;
};

// ================================
// Parámetro global: cliente BMI
// ================================
export const BMI_CUSTOMER_ID = 1274485;
export const BMI_CUSTOMER_ID_GYE = 1274950;
export const BMI_CUSTOMER_IDS = [BMI_CUSTOMER_ID, BMI_CUSTOMER_ID_GYE];

export const isBMI = (user) => BMI_CUSTOMER_IDS.includes(Number(user?.idCustomer));

export const getAsesorPhotoUrl = (id_salesman, bustCache = false) => {
  const isLocal =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  const base = isLocal
    ? `${window.location.protocol}//localhost:8080/images/SALESMEN/${id_salesman}.jpg`
    : `https://www.ultra-erp.pro/images/SALESMEN/${id_salesman}.jpg`;

  return bustCache ? `${base}?${Date.now()}` : base;
};
